import { Link as WaspRouterLink, routes } from 'wasp/client/router';
import { useQuery, getRegistrationOpen } from 'wasp/client/operations';
import { LoginForm } from 'wasp/client/auth';
import { AuthPageLayout } from './AuthPageLayout';

export default function Login() {
  const { data: regStatus } = useQuery(getRegistrationOpen);
  const registrationOpen = regStatus ? regStatus.enabled : true;

  return (
    <AuthPageLayout>
      <LoginForm
        appearance={{
          colors: {
            brand: 'hsl(221, 83%, 53%)',
            brandAccent: 'hsl(221, 83%, 43%)',
            submitButtonText: 'hsl(0, 0%, 98%)',
          },
        }}
      />
      <br />
      {registrationOpen && (
        <>
          <span className='text-sm font-medium text-gray-900 dark:text-gray-900'>
            Don't have an account yet?{' '}
            <WaspRouterLink to={routes.SignupRoute.to} className='underline'>
              go to signup
            </WaspRouterLink>
            .
          </span>
          <br />
        </>
      )}
      <span className='text-sm font-medium text-gray-900'>
        Forgot your password?{' '}
        <WaspRouterLink to={routes.RequestPasswordResetRoute.to} className='underline'>
          reset it
        </WaspRouterLink>
        .
      </span>
    </AuthPageLayout>
  );
}



